import { render, staticRenderFns } from "./SoftDeleteStudentVoucher.vue?vue&type=template&id=c3d76272&scoped=true&"
import script from "./SoftDeleteStudentVoucher.vue?vue&type=script&lang=js&"
export * from "./SoftDeleteStudentVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d76272",
  null
  
)

export default component.exports